<template>
  <v-progress-circular
    v-if="loading"
    color="primary"
    indeterminate
  />
  <chip
    v-else-if="hasValue"
    :payload="payload"
  />
  <div v-else>
    -
  </div>
</template>

<script>
import DataTableBooleanColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableBooleanColumn.vue';

export default {
  name: 'UserStoreAntecipacaoAutoColumn',
  extends: DataTableBooleanColumnVue,
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    hasValue() {
      return !!this.row && typeof this.row.antecipacaoAutomaticaAtiva === 'boolean';
    },
    loading() {
      return this.userStore.anteciparLoading;
    },
  },
  methods: {
    handleStatus(status = []) {
      return this.formatContent(
        status.map(
          (item) => {
            const override = this.handleItem(item);

            return {
              ...override,
              text: this.getItemLabel(override),
            };
          },
        ),
      );
    },
    getItemLabel(item) {
      return item.value ? 'Ativa' : 'Inativa';
    },
    handleItem(item) {
      return item;
    },
  },
  inject: {
    userStore: {
      default() {
        return {
          anteciparLoading: '',
        };
      },
    },
  },
};
</script>
